import React from "react";
import "./index.css";
import "./style.css";
import { Navbar } from "./components/Navbar";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Experience } from "./pages/Experience";
import { Home } from "./pages/home";
import { Process } from "./pages/Process";
import { Projects } from "./pages/Projects";
import { socialLinks } from "./data/portfolioData";

function Footer() {
  const year = new Date().getFullYear();
  const footerLinks = socialLinks.filter((s) => s.platform === "LinkedIn" || s.platform === "GitHub");

  return (
    <footer className="portfolio-footer">
      <p className="footer-copy">
        &copy; {year} <span>Lê Mạnh Hùng</span>. Built with React.
      </p>
      <div className="footer-links">
        {footerLinks.map((s) => (
          <a key={s.platform} href={s.url} target="_blank" rel="noopener noreferrer">
            {s.platform}
          </a>
        ))}
      </div>
    </footer>
  );
}

function App() {
  return (
    <div className="App" style={{ background: "var(--bg)", minHeight: "100vh" }}>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <Navbar>
        <main id="main-content">
          <Home />
          <Projects />
          <Process />
          <Experience />
          <About />
          <Contact />
        </main>
        <Footer />
      </Navbar>
    </div>
  );
}

export default App;
